import React, { Fragment, Text } from 'react';
import { ListView, PullToRefresh } from 'antd-mobile';

export default class MyListView extends React.Component {
    constructor(props) {
        super(props);

        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        let height = document.documentElement.clientHeight * 0.84;
        this.state = {
            data: [],
            dataSource,
            isLoading: true,
            height: height,
            page: 1,
            noMore: false,
            refreshing: false
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        this.initLoading();
    }

    initLoading() {
        this.setState({
            page: 1,
            data: [],
            noMore: false,
            refreshing: false
        }, () => {
            this.props.loadData(1);
        });
    }
    setData(res) {
        let { data } = this.state;
        if (res && res.length > 0) {
            data = [...data, ...res];
        }
        this.setState({
            data: data,
            page: this.state.page + 1,
            dataSource: this.state.dataSource.cloneWithRows(data),
            isLoading: false,
            noMore: res.length < 30,
        });


    }
    onEndReached() {
        if (this.state.noMore) {
            return;
        }
        this.props.loadData(this.state.page);
    }
    onRefresh() {
        this.setState({
            refreshing: true
        })
        setTimeout(() => {
            this.initLoading();
        }, 1000);
    }

    render() {
        let { createListItem, createCarousel, theme } = this.props;
        let { data } = this.state;
        return (
            <Fragment>
            {(data && data.length > 0) ?
                <ListView
                ref={el => this.lv = el}
                dataSource={this.state.dataSource}
                renderFooter={() => (<div style={{ padding: 10, textAlign: 'center', marginBottom: 100 }}>
                    {this.state.isLoading ? 'Loading...' : theme}
                </div>)}
                renderHeader={createCarousel}
                renderRow={createListItem}
                style={{
                    height: this.state.height,
                    // touchAction: 'none'
                }}
                pullToRefresh={
                    <PullToRefresh
                        direction={"down"}                                                
                        refreshing={this.state.refreshing}
                        onRefresh={this.onRefresh.bind(this)}
                    />}
                onEndReached={this.onEndReached.bind(this)}
                pageSize={30}
                scrollRenderAheadDistance={500}
                onEndReachedThreshold={10}
            /> :
            <div className="listKongCommon">
                <img src="https://cdn.huizhuanvip.com/mall/h5/img/icon_kong.png" className="listKong" alt="" />
                <div className="listKongText">暂无相关信息~</div>
            </div>    }
            </Fragment>
        );
    }
}
